// utils/toastService.js
import toast from "react-hot-toast";

const notify = {
  success: (msg) => toast.success(msg),
  error: (msg) => toast.error(msg),
  loading: (msg) => toast.loading(msg),
  plain: (msg) => toast(msg),
  info: (msg) =>
    toast(msg, {
      icon: "ℹ️",
      style: {
        color: "#000",
      },
    }),
};

export default notify;
